import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import ImmutableProptypes from 'react-immutable-proptypes'
import { Map } from 'immutable'
import classnames from 'classnames'
import { browserHistory } from 'react-router'

import { getSettings } from '_modules/settings/actions'
import { login, LOGIN, getProfileInfo, GET_PROFILE_INFO } from '_modules/user/actions'
import { getMindfulBreaks } from '_modules/mindful-breaks/actions'
import { createFieldMissingErrorMessage, deepCopyJSON } from '_utils/helperFunction'

import styles from './styles.css'

const mapStateToProps = ({ user, loading }) => ({
  user,
  isLoadingLogin: !!loading.get(LOGIN.ACTION),
  isLoadingProfileInfo: !!loading.get(GET_PROFILE_INFO.ACTION),
})

const mapDispatchToProps = {
  login,
  getMindfulBreaks,
  getProfileInfo,
  getSettings,
}

class Login extends PureComponent {
  static propTypes = {
    user: ImmutableProptypes.map,
    login: PropTypes.func.isRequired,
    getMindfulBreaks: PropTypes.func.isRequired,
    isLoadingLogin: PropTypes.bool.isRequired,
    getProfileInfo: PropTypes.func.isRequired,
    getSettings: PropTypes.func.isRequired,
  }

  static defaultProps = {
    user: new Map(),
  }

  state = {
    email: '',
    password: '',
  }

  componentWillReceiveProps({ isLoadingLogin, user, isLoadingProfileInfo }) {
    if (this.props.isLoadingLogin && !isLoadingLogin) {
      if (user.get('token')) {
        this.props.getMindfulBreaks()
        this.props.getProfileInfo()
        this.props.getSettings()
      } else {
        this.props.displayError('Invalid Credentials')
      }
    } else if (this.props.isLoadingProfileInfo && !isLoadingProfileInfo) {
      browserHistory.push('/')
    }
  }

  componentWillUnmount() {
    this.props.clearError()
  }

  onChange = event => {
    const { id, value } = event.target
    this.setState({
      [id]: value,
    })
  }

  onChangeTrim = event => {
    const { id, value } = event.target
    this.setState({
      [id]: value.trim(),
    })
  }

  onSubmit = event => {
    event.preventDefault()
    const { email, password } = this.state
    this.props.clearError()

    if (!email || !password) {
      this.props.displayError(createFieldMissingErrorMessage({ email, password }))
      return
    }

    const payload = {
      username: email,
      password,
    }

    this.props.login(payload)
  }

  onForgot = event => {
    event.preventDefault()
    browserHistory.push('/forgot')
  }

  formRef = null

  render() {
    const { email, password } = this.state
    return (
      <form
        ref={form => (this.formRef = form)}
        onSubmit={this.onSubmit}
        className={classnames(styles.main, styles.Grid)}
      >
        <div className={classnames(styles['Grid-cell'], styles['u-size1of1'])}>
          <input
            type="text"
            id="email"
            placeholder="Email"
            value={email}
            onChange={this.onChangeTrim}
            className={styles.input}
          />
        </div>
        <div className={classnames(styles['Grid-cell'], styles['u-size1of1'])}>
          <input
            type="password"
            id="password"
            placeholder="Password"
            value={password}
            onChange={this.onChange}
            className={styles.input}
          />
        </div>
        <div style={{ margin: 20 }} />
        <div className={classnames(styles['Grid-cell'], styles['u-size1of1'])}>
          <button type="submit" onClick={this.onSubmit} className={classnames(styles.button)}>
            LOGIN
          </button>
          <button type="submit" onClick={this.onForgot} className={classnames(styles.button)}>
            FORGOT PASSWORD
          </button>
        </div>
      </form>
    )
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Login)



// WEBPACK FOOTER //
// ./src/views/login/index.js